import React, { useState, useEffect } from 'react';
import { func, string, array } from 'prop-types';
import { useIntl } from 'react-intl';
import MultiselectCheckbox from '@hmhco/multiselect-checkbox/src/MultiselectCheckbox';

const SchoolAssociationField = ({
  schools,
  selectedSchools,
  handleChange,
  errorMessageId,
}) => {
  const { formatMessage } = useIntl();

  const [selectedOptions, setSelectedOptions] = useState(selectedSchools || []);

  useEffect(() => {
    setSelectedOptions(selectedSchools || []);
  }, [selectedSchools]);

  return (
    <MultiselectCheckbox
      allOptions={schools}
      selectedOptions={selectedOptions}
      setSelectedOptions={newOptions => {
        setSelectedOptions(newOptions);
        handleChange(newOptions);
      }}
      placeholder={formatMessage({
        id: 'earlyAccess.createUser.placeholder.schoolAssociation',
      })}
      actionButtonText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.apply',
      })}
      resetButtonText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.clear',
      })}
      singleOptionSelectedText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.single',
      })}
      multipleOptionsSelectedText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.multiple',
      })}
      getOptionLabel={option => option.name || ''}
      getOptionKey={option => option.id || option.name || ''}
      formLabelText={formatMessage({
        id: 'earlyAccess.createUser.label.schoolAssociation',
      })}
      formLabelId="schoolAssociation"
      required
      error={Boolean(errorMessageId)}
      formHelperText={
        errorMessageId ? formatMessage({ id: errorMessageId }) : ''
      }
    />
  );
};

SchoolAssociationField.propTypes = {
  schools: array.isRequired,
  selectedSchools: array,
  handleChange: func.isRequired,
  errorMessageId: string,
};

export default SchoolAssociationField;
